

















































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { MedicalSpecification } from "@/components/medicalTransmissionEdit/types";

@Component
export default class BasicInfo7 extends Vue {
  @Prop() tab!: MedicalSpecification;
}
